import axiosClient from "./axiosClient";
import { processParameters } from "./utils/utils";

/**
 * get data leaderboard qr scans
 * @param {number} storeId - ID of the store
 * @param {object} options - Filtering options
 * @param {string} options.timePeriod - Time period (e.g: LAST_30_DAYS)
 * @returns {Promise} - Promise with the leaderboard data
 */
export const getQRScansLeaderboardByStore = (storeId, options = {}) => {
    const { timePeriod = 'LAST_30_DAYS' } = options;
    
    const params = processParameters(
        [timePeriod.value, "timePeriod"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"],
        [0, "pageNumber"],
        [500, "pageSize"]
      
    );
    
    return axiosClient.get(`/qrscan/leaderboard/stores/${storeId}?${params}`);
};

/**
 * get data leaderboard qr scans for employee
 * @returns {Promise} - Promise with the leaderboard data
 */
export const getQRScansLeaderboardByStoreForEmployee = () => {
    return axiosClient.get(`/qrscan/employees/leaderboard`);
};

/**
 * Obtiene los datos del leaderboard de escaneos QR por tienda para una compañía específica
 * @param {number} companyId - ID de la compañía
 * @param {object} options - Opciones de filtrado
 * @param {string} options.timePeriod - Período de tiempo (ej: LAST_30_DAYS)
 * @returns {Promise} - Promesa con los datos del leaderboard
 */
export const getQRScansLeaderboardByCompany = (companyId, options = {}) => {
    const { timePeriod = 'LAST_30_DAYS' } = options;
    
    const params = processParameters(
        [timePeriod.value, "timePeriod"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"],
        [500, "pageSize"],
        [0, "pageNumber"]
    );
    
    return axiosClient.get(`/qrscan/leaderboard/companies/${companyId}?${params}`);
};

